import { AloftPrice } from '@aloft/toolkit-shared';

import type { ValueFormatter } from '../../types.js';

export const adjustment: ValueFormatter = (adj?: AloftPrice) => {
  if (!adj) return { str: [''] };

  if (!AloftPrice.isAloftPrice(adj)) throw new Error(`Invalid price: ${JSON.stringify(adj)}`);

  const str = adj.toString(true);
  if (AloftPrice.zero.equals(adj)) return { str: [str] };

  const isPositive = adj.gt(AloftPrice.zero);

  return {
    str: [`${isPositive ? '+' : ''}${str}`],
    color: isPositive ? 'textSuccess' : 'alertError',
  };
};
